import React, { useState } from "react";
import Box from "component/layoutComponents/Box/Box";
import { useTheme } from "styled-components";
import {
  StyledProductImage,
  StyledRowProduct,
  StyledCardContent,
  StyledSubStageEyeBrow,
} from ".././index.style";
import {
  useMediaQuery,
  Paper as MuiPaper,
  Menu,
  Divider,
  Stack,
  MenuItem,
  Theme,
  Grid,
  Box as MuiBox,
  Tooltip,
  Link
} from "@mui/material";
import { ApprovalIcon } from "component/commonComponents/Icon";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import moment from "moment";
import { StyledCardItems } from "../index.style";
import DefaultUptimeTheme from "component/theme/defaultTheme";
import EyeBrow from "../../eyeBrow/eyeBrow";
import { IconButton } from "../../ButtonComponents";
import Typography from "../../Typography/Typography";
import { CancelRounded } from "@mui/icons-material";
import { ORDER_STATUS } from "../../OrderRequestDetail/constant";
import { TicketStatus } from "component/ticketComponents/ticketCard/types";
import { mapColorEyeBrow } from "utils/mapColorEyeBrow";
import ErrorIcon from "@mui/icons-material/Error";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TimeUpdated from "component/ticketComponents/ticketCard/TimeUpated";
import ContentDescription from "component/ticketComponents/ticketCard/ContentDescription";
import { StyledTooltip } from "component/cardComponent/pcCard/pcCard.style";
import { TruncatedText } from "component/MarketPlace/Typography/Typography.style";

export interface IRequestCardProps {
  content: any;
  onViewDetails?: (orderedId: string) => void;
  onCancelOrder?: (orderItem: Record<string, any>) => void;
  locale?: any;
  tooltipStatusMessage?: any;
  updatedDate?: string;
}

type MenuContentProps = {
  showCancelButton?: boolean;
  onCancelOrder: () => void;
  onViewDetails?: any;
  locale?: any;
};

const OrderMenuItems = ({
  onCancelOrder,
  locale,
}: {
  onCancelOrder: () => void;
  locale: any;
}) => {
  const isSmallDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <>
      <MenuItem onClick={onCancelOrder} id="btn-requestcard-cancel">
        <Box display="flex">
          {isSmallDown && (
            <Box display={isSmallDown ? "flex" : "block"} paddingRight={4}>
              <CancelRounded color="error" />
            </Box>
          )}
          <Typography
            fontWeight={{ md: 600 }}
            fontSize={{ md: 14 }}
            color="error"
          >
            {locale?.cancelOrder}
          </Typography>
        </Box>
      </MenuItem>
    </>
  );
};

const MenuContent = ({
  showCancelButton = false,
  onCancelOrder,
  locale,
}: MenuContentProps) => {
  const isMediumDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <Stack>
      {showCancelButton && isMediumDown && <Divider />}
      {showCancelButton && (
        <OrderMenuItems onCancelOrder={onCancelOrder} locale={locale} />
      )}
    </Stack>
  );
};

const RequestCard = (props: IRequestCardProps) => {
  const {
    content,
    onViewDetails = () => {},
    onCancelOrder = () => {},
    locale,
    tooltipStatusMessage,
    updatedDate ='',
  } = props;
  const theme = useTheme() as typeof DefaultUptimeTheme;
  const [isHover, setIsHover] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openActionMenu = Boolean(anchorEl);
  const orderDetailsStatus = content?.status || content?.state;
  const assetTicketLocale = {...locale?.asset, ...locale?.ticket};
  let state = content?.state;
  const UNAVAIABLED = "N/A";

  const isCheckSubStage: boolean = true;

  const createdOn = content?.createDate || content?.createdOn;
  const products = content?.products;
  const requester = content?.requested_by?.name;
  let approver = content?.approval?.approved_by_name || content?.approval?.assigned_approver_name;
  const showMoreActionButton =
    orderDetailsStatus === ORDER_STATUS.PENDING_APPROVAL ||
    orderDetailsStatus === ORDER_STATUS.PENDING_APPROVAL_DELEGATED;

  const isSmallUp = useMediaQuery((theme: Theme) => 
    theme.breakpoints.up('sm')
  );
  const isMdDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const isMdUp = useMediaQuery((theme: Theme) => 
    theme.breakpoints.up('md')
  );
  const handleClickActionMenu = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    if (isSmallUp && showMoreActionButton) {
      setAnchorEl(event.currentTarget);
      return;
    }
  };

  const handleCloseActionMenu = () => {
    setAnchorEl(null);
  };

  const renderOriginalState = (isMapColor: boolean) => {
    let text = content?.status || content?.originalState;
    
    return isMapColor
      ? text?.toUpperCase()
      : assetTicketLocale[text?.toUpperCase()]
  };

  const eyeBrowOriginalStateColor = mapColorEyeBrow(
    renderOriginalState(true),
    theme
  );

  const renderState = (isMapColor: boolean) => {
    let text = isMapColor ? state?.toUpperCase() : assetTicketLocale[state?.toUpperCase()]?.toUpperCase();
    return text?.toUpperCase();
  };

  const eyeBrowStateColor = mapColorEyeBrow(
    renderState(true),
    theme
  );

  const handleMouseDown = (e: any) => {
    if (e.button === 0) {
      onViewDetails(content?._id);
    }
  };

  const tooltipMessage = (status: string) => {
    let message;
    switch (status) {
      case TicketStatus.OPEN:
        message = tooltipStatusMessage?.open;
        break;
      case TicketStatus.CLOSED:
        message = tooltipStatusMessage?.closed;
        break;
      case TicketStatus.AWAITING_APPROVAL:
        message = tooltipStatusMessage?.awaitingApproval;
        break;
      case TicketStatus.PENDING_APPROVAL:
          message = tooltipStatusMessage?.pendingApproval;
          break;
      case TicketStatus.APPROVED:
        message = tooltipStatusMessage?.approved;
        break;
      case TicketStatus.REJECTED:
        message = tooltipStatusMessage?.rejected;
        break;
      case TicketStatus.PREPARING_DEVICE:
        message = tooltipStatusMessage?.preparingDevice;
        break;
      case TicketStatus.CANCELLED:
        message = tooltipStatusMessage?.cancelled;
        break;
      case TicketStatus.RESOLVED:
        message = tooltipStatusMessage?.resolved;
        break;
      case TicketStatus.DEVICEINTRANSIT:
        message = tooltipStatusMessage?.deviceInTransit;
        break;
      case TicketStatus.INPROGRESS:
        message = tooltipStatusMessage?.inProgress;
        break;
      case TicketStatus.NOLONGERREQUIRED:
        message = tooltipStatusMessage?.noLongerRequired;
        break;
      case TicketStatus.PENDINGCANCELLATION:
        message = tooltipStatusMessage?.pendingCancellation;
        break;
      case TicketStatus.SUBMITTED:
        message = tooltipStatusMessage?.submitted;
        break;
      case TicketStatus.UNDERINVESTIGATION:
        message = tooltipStatusMessage?.underInvestigation;
        break;
      case TicketStatus.APPROVAL_REJECTED:
        message = tooltipStatusMessage?.approvalRejected;
        break;
      case TicketStatus.PCRETURN:
        message = tooltipStatusMessage?.pcReturn;
        break;
      case TicketStatus.ORDERING_DEVICE:
        message = tooltipStatusMessage?.orderingDevice;
        break;
      case TicketStatus.PREPARING_SHIPPING_MATERIALS:
        message = tooltipStatusMessage?.preparingShippingMaterials;
        break;
      case TicketStatus.COMPLETED:
        message = tooltipStatusMessage?.completed;
        break;
      case TicketStatus.SHIPPING:
        message = tooltipStatusMessage?.shipping;
        break;
      default:
        message = "";
        break;
    }
    return message;
  };

  const showingRequestActionButon = () => {
    return (
      <>
        <IconButton
          icon={MoreVertIcon}
          aria-label="View More Button"
          value="viewMoreButton"
          onClick={handleClickActionMenu}
          id="btn-requestcard-more"
        />
        <Menu
          anchorEl={anchorEl}
          open={openActionMenu}
          onClose={handleCloseActionMenu}
          disableScrollLock
        >
          <MenuContent
            showCancelButton={showMoreActionButton}
            onCancelOrder={() => {
              handleCloseActionMenu();
              onCancelOrder(content);
            }}
            locale={locale}
          />
        </Menu>
      </>      
    )
  };

  return (
    <MuiPaper
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      variant={isHover ? "elevation" : "outlined"}
      elevation={isHover ? 4 : 0}
      sx={{
        borderRadius: "8px",
        padding: "20px 0px",
        "&:hover": { border: 1, borderColor: "transparent" },
      }}
      data-ritm_number={content?._id}
    >
      <MuiBox
        display="flex"
        alignItems="center"
        flexDirection="column"
        padding={`${theme.uptimeSpace[8]}px`}
        gap="15px 0"
      >
        <Grid
          container
          display="flex"
          alignItems="center"
          gap={{ xs: "8px 0", md: "0px" }}
        >
          <Grid 
            item 
            xs={12}
            sm={12}
            md={4}
            minHeight="48px"
            display="flex"
            justifyContent="space-between"
          >
            <MuiBox display="flex" alignItems="center" gap="0 10px">
              <MuiBox
                width="38px"
                height="40px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <ApprovalIcon color={theme.uptimeColors.generalColors.icon.enabled} />
              </MuiBox>
              <StyledTooltip title={
                content?.requestItem?.shortDescription || 
                `${locale?.orderLabel} #${(content?._id)?.slice(0, 5)}`
                } placement="bottom-start">
                <TruncatedText
                  maxlines={1}
                  onClick={() => onViewDetails(content?._id)}
                  variant="overline"
                  sx={{
                    fontSize: `${theme.uptimeSpace[12]}px`,
                    fontWeight: '600',
                    lineHeight: '30px',
                    color: 'text.primary',
                    cursor: "pointer",
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                  id="lbl-requestcard-short_description"
                >
                  {content?.requestItem?.shortDescription ||
                  `${locale?.orderLabel} #${(content?._id)?.slice(0, 5)}`}
                </TruncatedText>
              </StyledTooltip>
            </MuiBox>
            {isMdDown && showMoreActionButton && showingRequestActionButon()}
          </Grid>
          <Grid 
            item 
            xs={12} 
            sm={12} 
            md={6}
            display="flex"
            justifyContent="center"
          >
            <MuiBox
              display="flex"
              justifyContent={isCheckSubStage ? "space-between" : "center"}
              alignItems="center"
              px={2}
              py={0}
            >
              <MuiBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                minWidth={{ xs: "auto", md: "auto", lg: "auto" }}
                maxWidth={{ xs: "unset", md: "120px", lg: "160px" }}
              >
                <EyeBrow
                  variant="filled"
                  sx={{
                    backgroundColor: eyeBrowStateColor?.background,
                    color: eyeBrowStateColor?.color,
                    fontWeight: 600,
                    height: `${theme.uptimeSpace[12]}px`,
                    lineHeight: `${theme.uptimeSpace[9]}px`,
                    fontSize: `${theme.uptimeSpace[6]}px`,
                  }}
                  label={renderState(false)}
                  endIcon={
                    tooltipMessage(renderState(true)) && (
                      <Tooltip
                        title={tooltipMessage(renderState(true))}
                      >
                        <MuiBox display="flex">
                          <ErrorIcon
                            sx={{ color: "#0000008c", width: `${theme.uptimeSpace[8]}px`, height: `${theme.uptimeSpace[8]}px` }}
                          />
                        </MuiBox>
                      </Tooltip>
                    )
                  }
                  id="lbl-requestcard-status"
                  data-ritm_number={content?._id} 
                />
              </MuiBox>
              {isCheckSubStage && (
                <>
                  <ChevronRightIcon
                    sx={{ width: { xs: "24px", sm: "60px" }, height: "24px" }}
                  />
                  <MuiBox
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <StyledSubStageEyeBrow
                      sx={{
                        backgroundColor: eyeBrowOriginalStateColor?.background,
                        padding: "3px 4px",
                        fontWeight: 600,
                        height: `${theme.uptimeSpace[12]}px`,
                        lineHeight: `${theme.uptimeSpace[9]}px`,
                        fontSize: `${theme.uptimeSpace[6]}px`,
                        color: eyeBrowOriginalStateColor?.color,
                        whiteSpace: 'unset'
                      }}
                      label={renderOriginalState(false)}
                      variant="filled"
                      endIcon={
                        tooltipMessage(
                          renderOriginalState(true)
                        ) && (
                          <Tooltip
                            title={tooltipMessage(
                              renderOriginalState(true)
                            )}
                          >
                            <MuiBox display="flex">
                              <ErrorIcon
                                sx={{ color: "#0000008c", width: `${theme.uptimeSpace[8]}px`, height: `${theme.uptimeSpace[8]}px` }}
                              />
                            </MuiBox>
                          </Tooltip>
                        )
                      }
                      id="lbl-requestcard-sub_status"
                      data-ritm_number={content?._id} 
                    />
                  </MuiBox>
                </>
              )}
            </MuiBox>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            display="flex"
            justifyContent={{ xs: 'space-between', sm: 'space-between', md: 'end' }}
            alignItems="center"
            gap="0 10px"
          >
            <MuiBox alignSelf="start" paddingRight="20px" display={{ xs: 'flex', sm: 'flex', md: 'none' }}>
              <Typography
                fontSize="14px"
                variant="overline"
                color="text.secondary"
                id="lbl-requestcard-number_sm"
              >
               {`#${content?.requestItem?.number || (content?._id)?.slice(0, 11)}`}
              </Typography>
            </MuiBox>
            <MuiBox justifyContent="end">
              <Link
                onMouseDown={handleMouseDown}
                sx={{ cursor: "pointer", textDecoration: "none" }}
                id="btn-requestcard-view_detail"
                data-ritm_number={content?._id}
                role="link"
                tabIndex={0}
                aria-label="View Details"
              >
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: theme.uptimeColors?.generalColors?.button?.hyperlink?.enabled,
                    '&:hover': {
                      color: theme.uptimeColors?.generalColors?.button?.hyperlink?.hover,
                    }
                  }} 
                  fontWeight={600}
                >
                  {locale?.viewDetail}
                </Typography>
              </Link>
            </MuiBox>
            {isMdUp && showMoreActionButton && showingRequestActionButon()}
          </Grid>
        </Grid>
        <MuiBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center' }}
          flexDirection={{ xs: "column", sm: 'column', md: "row" }}
          width={{ sm: '40%', md: '100%' }}
        >
          <MuiBox 
            display="flex" 
            alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center' }}
            flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          >
            <MuiBox alignSelf="start" paddingRight="20px" display={{ xs: 'none', sm: 'none', md: 'flex' }}>
              <Typography
                fontSize="14px"
                variant="overline"
                color="text.secondary"
                id="lbl-requestcard-number_md"
              >
               {`#${content?.requestItem?.number || (content?._id)?.slice(0, 11)}`}
              </Typography>
            </MuiBox>
            <ContentDescription
              label={locale?.requester?.toUpperCase()}
              name={requester || UNAVAIABLED}
            />
            <ContentDescription
              label={locale?.approver?.toUpperCase()}
              name={approver || UNAVAIABLED}
            />
          </MuiBox>
          <MuiBox 
            display="flex" 
            alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center' }}
            flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          >
            <TimeUpdated label={locale?.created?.toUpperCase()} date={moment(createdOn).format("ll")} />
            {state?.toUpperCase() === "CLOSED" && (
              <TimeUpdated
                label={assetTicketLocale["CLOSED"]?.toUpperCase()}
                date={moment(content?.updatedOn).format("ll")}
              />
            )}
            <TimeUpdated label={locale?.updated?.toUpperCase()} date={updatedDate} />
          </MuiBox>
        </MuiBox>
      </MuiBox>
      {products?.length > 0 && (
        <StyledCardContent>
          <StyledRowProduct>
              {products.map((item: any) => {
                return (
                  <StyledCardItems>
                    <StyledProductImage>
                      <img
                        src={item?.pictures[0]?.small}
                        alt={item?.genericName}
                        title={item?.genericName}
                        id="img-requestcard-picture"
                      />
                    </StyledProductImage>
                    <EyeBrow
                      color="default"
                      label={item.quantity}
                      variant="filled"
                      id="lbl-requestcard-quantity"
                    />
                  </StyledCardItems>
                );
              })}
          </StyledRowProduct>
        </StyledCardContent>
      )}
    </MuiPaper>
  );
};

export default RequestCard;
